import MaterialEcommerceScreen from './MaterialEcommerceScreen'

export default MaterialEcommerceScreen
